var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('button',{staticClass:"button is-primary",on:{"click":function($event){return _vm.openTab(_vm.$store.state.chargifyUrl)}}},[_vm._v("\n      Billing and subscription portal\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }